import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('createFieldForm');

    return {
        CREATE: t('create')
    };
};

export default useTranslation;
